import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, tap, throwError } from "rxjs";
import { env } from "../../env/env";


export interface ReportData {
  data: any[]
  parameters: Record<string, any>
}


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})


export class ReportService {
  baseUrl = env.apiUrl;

  constructor(private http: HttpClient) {

  }
  /**
    * Télécharge un rapport généré
    * @param blob Blob du rapport
    * @param filename Nom du fichier
    */

  downloadReport(blob: Blob, filename: string): void {
    try {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Erreur lors du téléchargement du rapport :', error)
    }
  }

  /**
   * Ouvre le rapport dans un nouvel onglet. En cas d'échec (popup bloquée), télécharge le fichier.
   * Garantit le bon type MIME (application/pdf) et révoque l'URL objet après un délai pour éviter les fuites mémoire.
   * @param blob Blob du rapport
   * @param filename Nom du fichier utilisé pour le fallback de téléchargement
   */
  openOrDownloadReport(blob: Blob, filename: string = 'rapport.pdf'): void {
    try {
      const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' })
      const file = new File([pdfBlob], filename, { type: 'application/pdf' })
      const url = window.URL.createObjectURL(file)
      const urlWithName = `${url}#filename=${encodeURIComponent(filename)}`
      const newTab = window.open(urlWithName, '_blank', 'noopener,noreferrer')
      if (!newTab) {
        this.downloadReport(pdfBlob, filename)
      } else {
        newTab.focus?.()
      }
      // Libération mémoire différée
      setTimeout(() => {
        window.URL.revokeObjectURL(url)
      }, 60000)
    } catch (error) {
      // Fallback en cas d'erreur inattendue
      this.downloadReport(blob, filename)
    }
  }
  generatePtaReport(format: string = 'pdf', data: any[], parameters: Record<string, any> = {}): Observable<Blob> {
    return this.generateReportFromPath('report-pta', format, data, parameters)
  }

  generatePtabReport(format: string = 'pdf', data: any[], parameters: Record<string, any> = {}): Observable<Blob> {
    return this.generateReportFromPath('report-ptab', format, data, parameters)
  }

  generatePpmReport(format: string = 'pdf', data: any[], parameters: Record<string, any> = {}): Observable<Blob> {
    return this.generateReportFromPath('report-ppm', format, data, parameters)
  }




  /**
  * Méthode générique pour générer un rapport depuis un endpoint
  */// ...existing code...
  generateReportFromPath(
    path: string,
    format: string = 'pdf',
    data: any[] = [],
    parameters: Record<string, any> = {}
  ): Observable<Blob> {
    const reportData: ReportData = {
      data,
      parameters
    };


    return this.http.post(
      `${this.baseUrl}report/${path}?format=${format}`,
      reportData,
      { responseType: 'blob' }
    ).pipe(
      tap((blob: any) => {
        //console.log('Type de la réponse:', blob?.type, blob);
      }),
      map((blob: Blob) => {
        if (!(blob instanceof Blob)) {
          throw new Error('La réponse du serveur n\'est pas un Blob valide');
        }
        return blob;
      }),
      catchError((error: any) => {
        console.error('Erreur lors de la génération du rapport:', error);
        return throwError(() => new Error('Impossible de générer le rapport.'));
      })

    );
  }

  // ...existing code...
  generateReportFromPath2(
    path: string,
    format: string = 'pdf',
    data: any[] = [],
    parameters: Record<string, any> = {}
  ): Observable<Blob> {
    const reportData: ReportData = { data, parameters };

    return this.http.post(
      `${this.baseUrl}report/${path}?format=${format}`,
      reportData,
      { responseType: 'blob' } // Angular sait que c'est un Blob
    ).pipe(
      tap((blob: Blob) => {
        //console.log('Type de la réponse:', blob.type, blob);
      }),
      catchError((error: any) => {
        console.error('Erreur lors de la génération du rapport:', error);
        return throwError(() => new Error('Impossible de générer le rapport.'));
      })
    );
  }

}
